import { Footer } from "../components/layout/Footer";
import { Header } from "../components/layout/Header";
import { FinalCTA } from "../components/sections/FinalCTA";
import { Hero } from "../components/sections/Hero";
import { IndustriesInsightsProcess } from "../components/sections/IndustriesInsightsProcess";
import { ManufacturerSection } from "../components/sections/ManufacturerSection";
import { MarketInsights } from "../components/sections/MarketInsights";
import { ProductsServices } from "../components/sections/ProductsServices";
import { ReachStatistics } from "../components/sections/ReachStatistics";
import { PageMeta } from "../components/ui/PageMeta";

export function HomePage() {
  return (
    <>
      <PageMeta title="IranTradeReach — Your Sourcing Partner in Iran" description="Iran-based product sourcing, supplier research, quotation comparison and commercial coordination for international buyers." alternatePath="/fa/" />
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <div className="hero-shell">
        <Header />
        <Hero />
      </div>
      <main id="main-content">
        <ProductsServices />
        <ReachStatistics />
        <IndustriesInsightsProcess />
        <ManufacturerSection />
        <MarketInsights />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
